module.exports = require("@adobe/pdfservices-node-sdk");